(function ($) {
    $(() => {

        function namevalidation(inputtxt) {
            const regexp = /[a-zA-Z áéíóöőúüűÁÉÍÓÖŐÚÜŰ\.'\-]*/gm;
            if (inputtxt.match(regexp)) {
                return true;
            }
            return false;
        }

        function resetNewsletterForm() {
            $('.js-newsletter-form').trigger('reset');
            $(".js-newsletter-form .form-group.is-focused").removeClass("is-focused");
            $(".js-newsletter-form .custom-label.is-focused").removeClass("is-focused");
            // grecaptcha.reset();
        }

        // front-form
        $('.js-newsletter-form').on('submit', function (e) {
            e.preventDefault();
            const $this = $(this);

            const first_name = $('#first_name').val();
            const last_name = $('#last_name').val();

            if (!namevalidation(first_name)) {
                delayedSwal({
                    title: ajax.translations.hibas_nev,
                    text: '',
                    button: ajax.translations.ok
                });
            } else if (!namevalidation(last_name)) {
                delayedSwal({
                    title: ajax.translations.hibas_nev,
                    text: '',
                    button: ajax.translations.ok
                });
            } else if ( $('.secondcheck').prop('checked') ) {
                $(this)
                    .find('.newsletter-btn')
                    .prop('disabled', true);
                const formdata = $this.serializeArray();
                //formdata[formdata.length] = { name: 'recaptcha', value: $(this).find('#g-recaptcha-response').val() };
                $.ajax({
                    url: ajax.ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'newsletter_form',
                        datas: formdata
                    },
                    success(data) {
                        const result = JSON.parse(data);
                        if (result.status == 'success') {
                          if (ajax.language == 'en') {
                              let successText = document.createElement('div');
                              successText.innerHTML = '<p class="swal__custom-content">' + ajax.whitepaper_en_content + '</p>';
                              successText.innerHTML += '<a href="' + ajax.whitepaper_en_btn_link + '" class="btn btn-primary swal__custom-btn">' + ajax.whitepaper_en_btn_txt + '</a>';
                              successText.innerHTML += '<a href="' + ajax.whitepaper_en_link + '" class="swal__back-to-homepage">' + ajax.whitepaper_en_link_txt + '</a>';
                              delayedSwal({
                                title: ajax.whitepaper_en_title,
                                content: successText,
                              });
                          }
                          else {
                            delayedSwal({
                                title: result.title,
                                text: result.message,
                                icon: result.icon,
                                button: 'ok'
                            });
                          }
                          resetNewsletterForm();
                        }
                        else {
                          delayedSwal({
                              title: result.title,
                              text: result.message,
                              icon: result.icon,
                              button: 'ok'
                          });
                        }
                    }
                }).done(response => {
                    $this.find('.newsletter-btn').prop('disabled', false);
                });
            } else {
                if (!$('.secondcheck').prop('checked')) {
                    $('.secondcheck_label').addClass('has-error-text');
                    delayedSwal({
                        title: ajax.news_chb_2,
                        text: '',
                        icon: 'error',
                        button: ajax.translations.ok
                    });
                }
            }
        });

        $('.secondcheck').change(() => {
            $('.secondcheck_label').removeClass('has-error-text');
        });

    });



})(jQuery);